{{#each this}}
  <li class='gallery__item'>
    <a href='{{urls.full}}'>
       <img src='{{urls.small}}' alt='{{alt_description}}' class='gallery-img' />
    </a>
   
  </li>
{{/each}}